// Components
import { DialogContent } from '@mui/material';
import { useCotizador } from '../../../hooks/others';
import { DialogCustom } from '../../templates';
import { FormModalSmsCode } from './FormModalSmsCode';

export function ModalSmsCode({ open = false, setOpen = () => null, aceptacionVerificarModalOTP, paramsCodeOTP }) {
  const { dataCotizar } = useCotizador();

  return (
    <DialogCustom open={open} setOpen={setOpen} disabledDismiss>
      <DialogContent className=" overflow-x-hidden  mt-16">
        <div className="flex flex-col items-center gap-7 lg:w-[700px]">
          <p className="text-base text-center">
            Hemos enviado un SMS con un código al siguiente número de teléfono:
            <b> {dataCotizar.datosPersonales?.telefono}</b>
            <span className="md:block">para verificar tu identidad.</span>
          </p>

          <FormModalSmsCode aceptacionVerificarModalOTP={aceptacionVerificarModalOTP} paramsCodeOTP={paramsCodeOTP} />
        </div>
      </DialogContent>
    </DialogCustom>
  );
}
